
import { Component, Prop } from 'vue-property-decorator';
import StackedForm from '../../../mixins/StackedForm';
import { mixins } from 'vue-class-component';
import VFormBuilder from '../../shared/form/VFormBuilder.vue';
import { InputType } from '@/enums/InputType';

@Component({
  components: { VFormBuilder },
})
export default class BannerForm extends mixins(StackedForm) {
  get items() {
    return [
      {
        name: 'de',
        type: InputType.File,
        label: `${this.$t('promo.form.banner')} (DE)`,
        default: null,
        accept: 'image/*',
      },
      {
        name: 'en',
        type: InputType.File,
        label: `${this.$t('promo.form.banner')} (EN)`,
        default: null,
        accept: 'image/*',
      },
    ];
  }

  public getData() {
    return { banner: this.$refs.form.form };
  }
}
